import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import Links, { PDF_DPE_EMBED_PATH } from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { isVisaoAdministrador } from '@/shared/constants/visao-sistema.constants';
import './utilitario-embed.css';

/**
 * Página interna que embute o editor PDF DPE (I Love DPE) via iframe.
 * O iframe aponta para `/pdf-dpe/` (proxy same-origin na API), evitando
 * bloqueio de conteúdo misto quando o SGI está em HTTPS.
 * Restrita à visão de administrador.
 */
export default function PdfDpePage() {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error('PdfDpePage deve ser usado dentro de um Provedor.');
  }
  if (!isVisaoAdministrador(context.authVisao)) {
    return <Navigate to={Links.Nao_Autorizado} replace />;
  }

  return (
    <div className="utilitario-embed">
      <iframe
        className="utilitario-embed__frame"
        src={PDF_DPE_EMBED_PATH}
        title="PDF DPE — editor de PDF da Defensoria"
        allow="fullscreen; clipboard-read; clipboard-write; downloads"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
